import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const Jwt = {
  AddAccountPage: lazy(() => import('src/pages/auth/add-account')),
};

// ----------------------------------------------------------------------

export const accountRoutes = [
  {
    path: 'account',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <AuthGuard>
          <AuthCenteredLayout>
            <Outlet />
          </AuthCenteredLayout>
        </AuthGuard>
      </Suspense>
    ),
    children: [
      { path: 'add-account', element: <Jwt.AddAccountPage /> },
    ]
  },
];
